<template>
  <j-modal :title="title"
           :width="width"
           :visible="visible"
           @ok="handleOk"
           @cancel="handleCancel"
           :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
           :destroyOnClose="true"
           cancelText="关闭">

    <product-tag-form ref="realForm"
                      @ok="submitCallback"
                      :disabled="disableSubmit"
                      :appList="appList"></product-tag-form>

  </j-modal>

</template>

<script>
import ProductTagForm from './ProductTagForm'

export default {
  name: 'ProductTagModal',
  components: {
    ProductTagForm,
  },
   props: {
    appList: {
      type: Array,
    },
  },
  data() {
    return {
      title: '',
      width: 900,
      visible: false,
      disableSubmit: false,
    }
  },
  methods: {
    add() {
      console.log(11111111111111)
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add()
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>